(function ($) {
    $.resetErrors = function ($form) {
        $form.find('.is-invalid').removeClass('is-invalid');
        $form.find('.form-text').remove();
    }
}(jQuery));